import(/* webpackMode: "eager" */ "/var/www/pediloo/app/global-error.tsx");
